import { jsx as _jsx } from "react/jsx-runtime";
import radiantOrangeUrl from '../../../assets/gems/radiant_orange.svg?inline';
export function RadiantOrange({ ...props }) {
    return _jsx("img", { ...props, src: radiantOrangeUrl, alt: 'RadiantOrangeImage' });
}
